import {customElement, property, state} from 'lit/decorators.js';
import {videoStyles} from './video.styles';
import {LitElement, html} from 'lit';
import {query} from "lit/decorators/query.js";
import '@/components/cookie-overlay/cookie-overlay'
import CookieLayer from "@/components/cookie-layer/cookie-layer";

/**
 * An example element.
 *
 * @slot - This element has a slot
 */
@customElement('sbk-video')
export class SbkVideo extends LitElement {

    @property({type: Boolean, attribute: 'is-remote'})
    isRemote = false;

    @property()
    src: string = ''

    @property()
    overlay: string = ''

    @query('iframe')
    iframe!: HTMLIFrameElement;

    @state()
    cookiesAccepted: boolean;

    constructor() {
        super();
        this.cookiesAccepted = CookieLayer.isCookieConsentLoaded();
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('third-party-cookies-accepted', this._onCookiesAccepted);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('third-party-cookies-accepted', this._onCookiesAccepted);
    }

    static get styles() {
        return videoStyles;
    }

    render() {
        if (this.isRemote && !this.cookiesAccepted) {
            return html`
                <sbk-cookie-overlay overlay=${this.overlay}></sbk-cookie-overlay>
            `;
        }
        if (this.isRemote && this.cookiesAccepted) {
            return html`
            <div class='video-container'>
                <iframe class="cookie-consent-iframe" src=${this.src} frameborder='0' title="video"
                        allowfullscreen></iframe>
            </div>
        `;
        }
        return html`
            <video controls controlslist="nodownload">
                <source src=${this.src}>
            </video>
        `;
    }

    _onCookiesAccepted = () => {
        this.cookiesAccepted = true;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'sbk-video': SbkVideo;
    }
}

